export default {
  title: 'Segredo de assinatura do webhook',
  warning:
    'Guarde este segredo agora — não voltará a ser apresentado. Utilize-o para verificar o cabeçalho X-Webhook-Signature.',
  done: 'Concluído',
};
